document.addEventListener('DOMContentLoaded', function () {
  const bsubDiv = document.querySelector('div.bsub-widget__group[data-bsub-selling-plan-group-id="67a4f0df0279ead55d579be2658efb265076968d"]');
  if (bsubDiv) {
    bsubDiv.style.display = 'none';
  }
});
document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[action="/cart/add"]');
  const sellingPlanInput = form.querySelector('[name="selling_plan"]');
  const popup = document.createElement('div');
  const addToCartButton = document.getElementById('ProductSubmitButton-template--17583153086658__main');
  const qtyInput = document.getElementById('Quantity-template--17583153086658__main');
  const productData = window.BOLD.subscriptions.data.platform.product; // Assume it's already on the page
  const DROPSTREET_PLAN_GROUP_ID = "67a4f0df0279ead55d579be2658efb265076968d"; // Matches the one for Dropstreet Reminders

  // Extract Dropstreet Reminders plans
  const dropstreetPlans = (productData.selling_plan_groups || [])
    .find(group => group.id === DROPSTREET_PLAN_GROUP_ID)?.selling_plans || [];

    console.log(dropstreetPlans);

window.formatPhoneInput = function(input) {
  // Remove all non-digit characters
  let digits = input.value.replace(/\D/g, '');

  // Limit to 10 digits
  digits = digits.slice(0, 10);

  // Format as XXX-XXX-XXXX
  let formatted = digits;
  if (digits.length > 6) {
    formatted = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  } else if (digits.length > 3) {
    formatted = `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }

  input.value = formatted;
};

const popupTemplates = {
  1: `
    <div class="popup">
    <div class="icon-popup">
      <img src="${window.assetUrls.icon}" alt="icon">
    </div>
    <h2>Might want more later?<br />You can reorder through text message!</h2>
    <p class="subtitle">First – we text you. Then – You can reply to the text to reorder.</p>

    <div class="popup-form">
      <div class="popup-field">
        <label for="checkin">When do you want a check-in:</label>
        <small>No commitment required</small>
        <select id="subscription-plan-select">
          <option value="">e.g. 2 weeks, 1 month</option>
          ${dropstreetPlans.map(plan => `<option value="${plan.id}">${plan.name}</option>`).join('')}
        </select>
      </div>

      <div class="popup-field">
        <label for="phone">Enter your mobile number:</label>
        <small>No spam texts here</small>
        <input type="text" id="subscription-phone" placeholder="e.g. +9178675309"  />
      </div>

      <div class="info">See how it works <i>→ </i> <span class="tooltip">?
        <span class="tooltip-text">
            <span style="font-size:11px">Re-order through text message! <br><br>Get a text reminder for easy re-orders.<br> Just REPLY TO BUY! We simply save your payment and shipping info (securely) for easy future ordering. FREE TO SIGN UP!</span>
            <br><br>
            You are subscribing to receive promotion text messages (SMS & MMS). Message and data rates may apply. To successfully make future purchases through SMS, you are authorizing the use of the existing payment and shipping information you save on your account.
        </span>
    </span></div>

      <button  class="btn-popup" id="confirm-subscription">Yes, send a check-in</button>
    </div>

    <button class="dismiss" id="cancel-subscription">Maybe next time</button>
    <p id="phoneError" style="color:red; display:none; margin-top:10px;">Please enter a valid phone number.</p>
  </div>
  `,
  2: `
     <div class="popup">
    <div class="icon-popup">
      <img src="${window.assetUrls.icon}" alt="icon" />
    </div>
    <h2>Re-order with 1 text?</h2>
    <p class="subtitle">Tell us when you want us to text you & if you want to re-order, just reply to the text to buy again. SUPER EASY!</p>

    <div class="popup-form">

      <div class="fields-row">
      <div class="popup-field field-left">
        
       
        <input type="text" id="subscription-phone" placeholder="Enter your mobile number:"   />
         <small>We’ll only text you a check-in text—no spam </small>
      </div>

      <div class="popup-field field-right">
        
       
        <select id="subscription-plan-select">
          <option value="">Select check-in date</option>
          ${dropstreetPlans.map(plan => `<option value="${plan.id}">${plan.name}</option>`).join('')}
        </select>
         <small>No commitment required</small>
      </div>

      </div>

      <button  class="btn-popup"  id="confirm-subscription">All set</button>
    </div>

    <button class="dismiss" id="cancel-subscription">Maybe next time</button>
    <div class="info">See how it works <i>→ </i> <span class="tooltip">?
        <span class="tooltip-text">
            <span style="font-size:11px">Re-order through text message! <br><br>Get a text reminder for easy re-orders.<br> Just REPLY TO BUY! We simply save your payment and shipping info (securely) for easy future ordering. FREE TO SIGN UP!</span>
            <br><br>
            You are subscribing to receive promotion text messages (SMS & MMS). Message and data rates may apply. To successfully make future purchases through SMS, you are authorizing the use of the existing payment and shipping information you save on your account.
        </span>
    </span></div>
  </div>
  `,
  3: `
    <div class="popup">
    <div class="icon-popup">
      <img src="${window.assetUrls.icon2}" alt="icon">
    </div>
    <h2>Might want to re-order through text?</h2>
    <p class="subtitle">We’ll text you, in case you want to re-order,<br>just reply to the text to buy again</p>

    <div class="popup-form">
      <div class="popup-field">
        <label for="checkin">Pick your check-in date:</label>
        <small>No commitment required</small>
        <select id="subscription-plan-select">
          <option value="">e.g. 2 weeks, 1 month</option>
          ${dropstreetPlans.map(plan => `<option value="${plan.id}">${plan.name}</option>`).join('')}
        </select>
      </div>

      <div class="popup-field">
        <label for="phone">Enter your mobile number:</label>
        <small>No spam texts here</small>
        <input type="text" id="subscription-phone" placeholder="e.g. +9178675309"  />
      </div>

      <div class="info">See how it works <i>→ </i> <span class="tooltip">?
        <span class="tooltip-text">
            <span style="font-size:11px">Re-order through text message! <br><br>Get a text reminder for easy re-orders.<br> Just REPLY TO BUY! We simply save your payment and shipping info (securely) for easy future ordering. FREE TO SIGN UP!</span>
            <br><br>
            You are subscribing to receive promotion text messages (SMS & MMS). Message and data rates may apply. To successfully make future purchases through SMS, you are authorizing the use of the existing payment and shipping information you save on your account.
        </span>
    </span></div>

      <button  class="btn-popup" id="confirm-subscription">Yes, send a check-in</button>
    </div>

    <button class="dismiss" id="cancel-subscription">Maybe next time</button>
    <p id="phoneError" style="color:red; display:none; margin-top:10px;">Please enter a valid phone number.</p>
  </div>
  `,
  4: `
    <div class="popup">
    <div class="icon-popup">
      <img src="${window.assetUrls.icon2}" alt="icon">
    </div>
    <h2>Interested in re-ordering<br>with one text in the future?</h2>
    <p class="subtitle">We’ll send you a check-in text & if you want to re-order:<br>
just reply to the text to buy again! Super Easy!</p>

    <div class="popup-form">
      

      <div class="popup-field">
        
        
        <input type="text" id="subscription-phone" placeholder="Enter your mobile number:"  />
        <small>We’ll only text you a check-in text—no spam </small>
      </div>

      <div class="popup-field">
        <select id="subscription-plan-select">
          <option value="">Select check-in date</option>
          ${dropstreetPlans.map(plan => `<option value="${plan.id}">${plan.name}</option>`).join('')}
        </select>
        <small>No commitment required</small>
      </div>

     

      <button  class="btn-popup" id="confirm-subscription">All set</button>
<button class="dismiss" id="cancel-subscription">Maybe next time</button>
       <div class="info">See how it works <i>→ </i> <span class="tooltip">?
        <span class="tooltip-text">
            <span style="font-size:11px">Re-order through text message! <br><br>Get a text reminder for easy re-orders.<br> Just REPLY TO BUY! We simply save your payment and shipping info (securely) for easy future ordering. FREE TO SIGN UP!</span>
            <br><br>
            You are subscribing to receive promotion text messages (SMS & MMS). Message and data rates may apply. To successfully make future purchases through SMS, you are authorizing the use of the existing payment and shipping information you save on your account.
        </span>
    </span></div>
    </div>

    
    <p id="phoneError" style="color:red; display:none; margin-top:10px;">Please enter a valid phone number.</p>
  </div>
  `

};


//if there are no subscriptions attached to a product skip the whole thing
if(Object.keys(dropstreetPlans).length > 0){
 
  // Create popup content
  popup.id = 'custom-subscription-popup';
  popup.style = 'position:fixed; z-index:9999; top:0; left:0; width:100vw; height:100vh; background:rgba(0,0,0,0.6); visibility:hidden; ';

  

  const popupVariant = Math.floor(Math.random() * 4) + 1; // 1 to 4
//const popupVariant = 4;
  console.log("POPUP VARIANT"+ popupVariant);

  popup.innerHTML = popupTemplates[popupVariant];
  loadPopupCSS(popupVariant);

  setTimeout(() => {
  const phoneInput = popup.querySelector('#subscription-phone');
  if (phoneInput) {
    phoneInput.addEventListener('input', function () {
      window.formatPhoneInput(this);
    });
  }
}, 0);
  
  
  //popup.style.display = 'none';
  document.body.appendChild(popup);

  // Intercept form submit
  let intercept = true;
  

  // Intercept actual click on the button, not the form submit
  addToCartButton.addEventListener('click', function (e) {
    if (intercept) {
      
      let selected = document.querySelector('input[name="bsub-selling-plan-group"]:checked');

      if (selected) {
        if (selected.value === "once") {
          console.log("Currently one-time");
          e.preventDefault();
          popup.classList.add('show');

        } else {
          console.log("Currently subscription, plan ID:", selected.value);
        }
      }
      
      
    }
  });

/*
 // Intercept actual click on the button, not the form submit
  addToCartButton.addEventListener('click', function (e) {
    const oneTimeRadio = document.querySelector('input[type="radio"][data-type="one_time"]');
  const hasAnyRadios = document.querySelectorAll('input[type="radio"][data-type]').length > 0;
    console.log ("hasAnyRadios "+ hasAnyRadios);
    const shouldShowPopup =
    intercept &&
    (
      (oneTimeRadio && oneTimeRadio.checked) || // Case 1: one-time radio is checked
      (!hasAnyRadios)                          // Case 2: no subscription radios at all
    );

  if (shouldShowPopup) {
    e.preventDefault();
    popup.classList.add('show');
  }
  });


*/
  
  // Handle Yes
  document.getElementById('confirm-subscription').addEventListener('click', function () {
    const selectedPlan = document.getElementById('subscription-plan-select').value;
    const phone = document.getElementById('subscription-phone').value;

    if (!selectedPlan) {
      alert('Please select a subscription plan.');
      return;
    }

    if (!phone) {
      alert('Please enter your phone number.');
      return;
    }
    
      sellingPlanInput.value = selectedPlan;

      // Add phone number to a hidden input or cart attributes (if needed)
      const phoneInput = document.createElement('input');
      phoneInput.type = 'hidden';
      phoneInput.name = 'properties[Phone Number]';
      phoneInput.value = formatPhoneNumber(phone);
      form.appendChild(phoneInput);

      const quantityInput = document.createElement('input');
    quantityInput.type = 'hidden';
    quantityInput.name = 'quantity';
    quantityInput.value = qtyInput.value;
    form.appendChild(quantityInput);

      popup.style.display = 'none';
      intercept = false;
      logPopupEvent(popupVariant, true,true);
    
  });

  // Handle No
  document.getElementById('cancel-subscription').addEventListener('click', function () {
    popup.style.display = 'none';
    intercept = false;

       const quantityInput = document.createElement('input');
    quantityInput.type = 'hidden';
    quantityInput.name = 'quantity';
    quantityInput.value = qtyInput.value;
    form.appendChild(quantityInput);
    logPopupEvent(popupVariant, false,true);
  });

     function formatPhoneNumber(phone) {
    phone = phone.trim(); // Remove leading/trailing spaces
       /* if (!phone.startsWith('+1')) {
            phone = '+1' + phone;
        }
        return phone;
    */
       // Remove all non-digit characters
      phone = phone.replace(/\D/g, '');
    
      // Limit to first 10 digits
      phone = phone.substring(0, 10);
    
      // Return formatted with +1 prefix
      return '+1' + phone;
      
    }
}



 function logPopupEvent(popupNumber, signed = false, submit_form=false) {
    fetch('https://dropstreet.co/api/partner/log-popup', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({
            popup_number: popupNumber,
            signed: signed,
            source: "wells"
        })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error("Failed to log popup event");
        }
        return response.json();
    })
    .then(data => {
        console.log("Popup logged:", data);
        if(submit_form==true){
           form.submit();
        }
    })
    .catch(error => {
        console.error("Error logging popup:", error);
        if(submit_form==true){
          form.submit();
        }
    });
}


function loadPopupCSS(variant) {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = window.popupCssVariants[variant];
  document.head.appendChild(link);
}

  
});
/*
document.addEventListener('DOMContentLoaded', function () {
 
  const form = document.getElementById('product-form-template--17583153086658__main');
  const addToCartButton = document.getElementById('ProductSubmitButton-template--17583153086658__main');

  const popup = document.getElementById('phonePopup');
  const phoneInput = document.getElementById('phoneInput');
  const phoneError = document.getElementById('phoneError');
  const popupYes = document.getElementById('popupYes');
  const popupNo = document.getElementById('popupNo');

  let submitMethod = null;

  // Intercept actual click on the button, not the form submit
  addToCartButton.addEventListener('click', function (e) {
    e.preventDefault(); // this is crucial
    if (popup.style.display !== 'block') {
      popup.style.display = 'block';
    }
  });

  // If user clicks NO – submit without custom field
  popupNo.addEventListener('click', function () {
    popup.style.display = 'none';
    form.submit(); // default Shopify submission
  });

  // If user clicks YES – validate phone, then add it as custom property and submit
  popupYes.addEventListener('click', function () {
    const phone = phoneInput.value.trim();
    if (!/^\+?\d{7,15}$/.test(phone)) {
      phoneError.style.display = 'block';
      return;
    }

    phoneError.style.display = 'none';

    // Inject the phone number as a custom property
    const propertyInput = document.createElement('input');
    propertyInput.type = 'hidden';
    propertyInput.name = 'properties[Phone Number]';
    propertyInput.value = phone;
    form.appendChild(propertyInput);

    popup.style.display = 'none';
    form.submit(); // proceed with form submission
  });
});
*/

/*
document.addEventListener("DOMContentLoaded", function () {
  const addToCartBtn = document.querySelector('button.product-form__submit');

  // Replace this with your own check logic for subscription group
  const isSubscriptionProduct = () => {
    // Example condition: product has a specific selling plan group name or ID
    // You could check for presence of a hidden input or a class name
    return document.querySelector('[data-selling-plan-group-id="123456"]') !== null;
  };

  const showPopup = () => {
    document.getElementById('phone-popup').style.display = 'block';
  };

  const hidePopup = () => {
    document.getElementById('phone-popup').style.display = 'none';
  };

  const validatePhone = (phone) => {
    return /^\+?[0-9\s\-]{7,15}$/.test(phone);
  };

  addToCartBtn.addEventListener('click', function (e) {
    if (!isSubscriptionProduct()) return;

    e.preventDefault(); // Stop default add to cart behavior

    showPopup(); // Show custom phone popup
  });

  document.getElementById('popup-ok').addEventListener('click', function () {
    const phoneInput = document.getElementById('popup-phone');
    const errorMsg = document.getElementById('popup-error');
    const phoneValue = phoneInput.value.trim();

    if (!validatePhone(phoneValue)) {
      errorMsg.style.display = 'block';
      return;
    }

    errorMsg.style.display = 'none';

    // OPTIONAL: Store phone number in hidden input for form submission
    const hiddenPhone = document.createElement('input');
    hiddenPhone.type = 'hidden';
    hiddenPhone.name = 'properties[Phone Number]';
    hiddenPhone.value = phoneValue;
    document.querySelector('form').appendChild(hiddenPhone);

    hidePopup();

    // Submit the form programmatically
    addToCartBtn.closest('form').submit();
  });
});
*/